import React from "react"
// import PropTypes from "prop-types"
import { makeStyles } from "@material-ui/core/styles"
import Button from "@material-ui/core/Button"
import Dialog from "@material-ui/core/Dialog"
import DialogTitle from "@material-ui/core/DialogTitle"
import List from "@material-ui/core/List"
import ListItem from "@material-ui/core/ListItem"
import ListItemText from "@material-ui/core/ListItemText"
import Typography from "@material-ui/core/Typography"
// import AddIcon from '@material-ui/icons/Add';

const useStyles = makeStyles((theme) => ({
  button: {
    background: theme.palette.background.paper,
  },
  root: {
    background: theme.palette.background.paper,
    // margin: 0,//theme.spacing(1),
    // width: "100%",//"calc(100% - " + theme.spacing(2) + "px)",
  },
}))

function DialogList({ listItems, onClose, open, selectedValue }) {
  const handleClose = () => {
    onClose(selectedValue)
  }
  const handleListItemClick = (value) => {
    onClose(value)
  }

  return (
    <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open}>
      <DialogTitle id="simple-dialog-title">Select a document</DialogTitle>

      <List>
        {listItems
          ? listItems.map((item) => {
              return (
                <ListItem button onClick={() => handleListItemClick(item)} key={item.title}>
                  <ListItemText primary={item.title} />
                </ListItem>
              )
            })
          : "No documents yet"}

        <ListItem autoFocus button onClick={() => handleListItemClick(null)}>
          <ListItemText primary="Cancel" />
        </ListItem>
      </List>
    </Dialog>
  )
}

export default function DocumentsDialog({ buttonText, files, setter, type }) {
  const [open, setOpen] = React.useState(false)
  const [selectedValue, setSelectedValue] = React.useState({})
  const classes = useStyles()

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = (newValue) => {
    setOpen(false)
    setSelectedValue(newValue)
    if (setter && type && newValue && newValue.id) {
      setter(type, newValue.id)
    }
  }

  return (
    <div id={type}>
      {selectedValue ? (
        <Typography variant="subtitle1">Selected: {selectedValue.title}</Typography>
      ) : (
        ""
      )}
      <Button
        className={classes.button}
        color="primary"
        variant="outlined"
        onClick={handleClickOpen}
      >
        {buttonText || "Choose Document"}
      </Button>
      <DialogList
        listItems={files}
        onClose={handleClose}
        open={open}
        selectedValue={selectedValue}
      />
    </div>
  )
}

// DialogList.propTypes = {
//   onClose: PropTypes.func.isRequired,
//   open: PropTypes.bool.isRequired,
//   selectedValue: PropTypes.string.isRequired,
// }

// DocumentsDialog.propTypes = {
//   files: PropTypes.array.isRequired,
//   buttonText: PropTypes.string,
// }
